// From Material-ui nextjs sample https://github.com/mui-org/material-ui/tree/master/examples/nextjs
import { QueryClientProvider } from '@tanstack/react-query';
import {
  RouterProvider,
  createBrowserRouter,
  redirect,
} from 'react-router-dom';

import { getGamesQueryOptions } from './api/getGames';
import { AuthProvider } from './authentication/authContext';
import { authLoader, publicLoader } from './authentication/authLoader';
import { PopupProvider } from './components/confirmation';
import { ErrorBoundary } from './components/errorBoundary';
import { SidebarProvider } from './components/ui/sidebar';
import { Toaster } from './components/ui/sonner';
import { ToastProvider } from './components/ui/toast';
import { queryClient } from './lib/react-query';
import ErrorPage from './routes/error-page';
import { gameRoute } from './routes/game/route';
import Root from './routes/root';

const router = createBrowserRouter([
  {
    path: '/',
    id: 'root',
    element: <Root />,
    loader: authLoader,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        loader: () => redirect('/game'),
      },
      {
        path: 'login',
        loader: publicLoader,
        lazy: () => import('@/routes/auth/login'),
        children: [
          {
            path: 'login-form',
            lazy: () => import('@/routes/auth/login-form'),
          },
          {
            path: 'sso-microsoft',
            lazy: () => import('@/routes/auth/sso-microsoft'),
          },
        ],
      },
      {
        path: 'logout',
        lazy: () => import('@/routes/auth/logout'),
      },
      {
        path: 'game',
        loader: () => queryClient.ensureQueryData(getGamesQueryOptions()),
        lazy: () => import('@/routes/game/gameList'),
      },
      { ...gameRoute(queryClient) },
    ],
  },
]);
const MyApp = () => {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ToastProvider>
            <SidebarProvider>
              <PopupProvider>
                <RouterProvider router={router} />
                <Toaster position="top-center" />
              </PopupProvider>
            </SidebarProvider>
          </ToastProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
};

export default MyApp;
